export const COMPONENT_ID = 'template-save-status';

export const TEMPLATE_ALWAYS_SAVED_V2 = [
    'Vehicle details (inventory type and YMMT)',
    'Protection Products: Rated, Non-Rated, and Manual',
    'Manual Accessories',
    'Manual Incentives (Rebates) and Dealer Cash'
];

export const TEMPLATE_NEVER_SAVED_V2 = ['Customer information', 'Trade-ins'];

export const TEMPLATE_HEADER_V2 = 'Template Save Status';
